import { getField, updateField } from "vuex-map-fields";

const defaultState = () => {
  return {
    wizard: {
      billingAgree: false,
      quick_feed_type: "",
      feed_class: "",
      barcode_start: "",
      barcode_end: "",
      lab_id_start: "",
      lab_id_end: "",
      selectedComponents: [],
      showCalibrate: false,
      showCutting: false,
      currentStep: 1,
      isBulk: false,
      prepopulatePackagesAndComponents: false,
      sampleIds: [],
      barcodes: [],
      returnStep: false, // Next step override
      steps: [
        {
          title: "Sample Information",
          component: "SampleInformationStep"
        },
        {
          title: "Imaging",
          component: "ImagingStep"
        },
        {
          title: "Packages and Components",
          component: "PackageSelectionStep"
        },
        {
          title: "Billing",
          component: "BillingStep"
        },
        {
          title: "Review and Edit",
          component: "ReviewStep"
        },
        {
          title: "Shipping",
          component: "ShipmentSelectionStep"
        }
      ],
      newSteps: [
        {
          title: "Sample Information",
          component: "SampleInformationStep"
        },
        // {
        //   title: "Imaging",
        //   component: "ImagingStep"
        // },
        {
          title: "Packages and Components",
          component: "PackageSelectionStep"
        },
        // {
        //   title: "Billing",
        //   component: "BillingStep"
        // },
        {
          title: "Review and Edit",
          component: "ReviewStep"
        }
        // {
        //   title: "Shipping",
        //   component: "ShipmentSelectionStep"
        // }
      ],
      bulkSteps: [
        {
          title: "Sample Information",
          component: "SampleInformationStep"
        }
      ],
      error: {
        message: ""
      }
    }
  };
};

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    getField,
    steps(state) {
      return state.wizard.steps;
    },
    stepId(state, getters) {
      return component_name => {
        let indexhere = getters.steps.findIndex(
          step => step.component === component_name
        );

        // findIndex returns -1 if not found
        if (indexhere === -1) {
          indexhere = getters.steps.length + 1;
        }

        return indexhere;
      };
    },
    currentStepComponentTitle(state) {
      return state.wizard.steps[state.wizard.currentStep - 1].component;
    },

    /* new Steps Plugin */

    newSteps(state) {
      return state.wizard.newSteps;
    },
    newStepId(state, getters) {
      return component_name => {
        let indexhere = getters.newSteps.findIndex(
          step => step.component === component_name
        );

        // findIndex returns -1 if not found
        if (indexhere === -1) {
          indexhere = getters.newSteps.length + 1;
        }

        return indexhere;
      };
    },
    currentNewStepComponentTitle(state) {
      return state.wizard.newSteps[state.wizard.currentStep - 1].component;
    }
  },
  mutations: {
    updateField,
    initializeState(state) {
      Object.assign(state, defaultState());
    },
    setError(state, message = "") {
      state.wizard.error.message = message;
    },
    resetWizard(state) {
      Object.assign(state, defaultState());
    }
  }
};
